import { useAllLanguages, useLanguages } from 'hooks/queries/languages';
import formatOptions from 'utils/form/formatOptions';

const useLanguagesOptions = () => {
  const { data } = useLanguages();

  return { languagesOptions: formatOptions(data) };
};

export default useLanguagesOptions;

export const useAllLanguagesOptions = () => {
  const { data } = useAllLanguages();

  return { languagesOptions: formatOptions(data) };
};
